import { render, staticRenderFns } from "./EditorContainer.vue?vue&type=template&id=0255f251&scoped=true&"
import script from "./EditorContainer.vue?vue&type=script&lang=js&"
export * from "./EditorContainer.vue?vue&type=script&lang=js&"
import style0 from "./EditorContainer.vue?vue&type=style&index=0&id=0255f251&prod&lang=scss&scoped=true&"
import style1 from "./EditorContainer.vue?vue&type=style&index=1&id=0255f251&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0255f251",
  null
  
)

export default component.exports